import { forwardRef, useId } from 'react';
import { cn } from 'lib/cn';
import { Field } from './Field';

/** Labelled multi-line text input. */
export const TextArea = forwardRef(function TextArea(
  { label, error, hint, required, id, rows = 3, className, containerClassName, ...props },
  ref,
) {
  const autoId = useId();
  const inputId = id || autoId;

  return (
    <Field
      label={label}
      htmlFor={inputId}
      error={error}
      hint={hint}
      required={required}
      className={containerClassName}
    >
      <textarea
        id={inputId}
        ref={ref}
        rows={rows}
        className={cn(
          'w-full rounded-lg border bg-white px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 transition focus:outline-none focus:ring-2 focus:ring-brand-500/40',
          error ? 'border-red-400' : 'border-surface-300',
          className,
        )}
        {...props}
      />
    </Field>
  );
});

export default TextArea;
